import { render, staticRenderFns } from "./message-face.vue?vue&type=template&id=08f8d93c&scoped=true"
import script from "./message-face.vue?vue&type=script&lang=ts"
export * from "./message-face.vue?vue&type=script&lang=ts"
import style0 from "./message-face.vue?vue&type=style&index=0&id=08f8d93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f8d93c",
  null
  
)

export default component.exports